/**
 * A {@link ComboboxOption Combobox.Option} is a compound component for use
 * with a {@link Combobox Combobox}, representing an available option.
 *
 * @returns {null} This component intentionally returns `null`. We
 * anticipate this component is used within a `<Combobox />`
 * which will pass its `children` to a hook which will iterate through the
 * children and convert each to a node. We do it this way so the
 * consuming API is using JSX.
 */
const ComboboxOption = () => {
    return null;
};
export default ComboboxOption;
//# sourceMappingURL=ComboboxOption.js.map